<template>
    <div class="body-panel">
        <div class="body-panel-content">
            <div class="body-panel-content-start flex">
                <div class="login-page-bg">
                </div>
                <div class="login-page">
                    <div class="login-logo" v-if="info.Image != null">
                        <img class="login-logo-img" :src="(info.StartImage ? info.StartImage: info.Image)" />
                    </div>
                    <div class="register">
                        <div class="login">
                            <template v-if="result == null">
                                <!-- Индикация текущего шага регистрации -->
                                <div v-if="totalSteps > 1" class="form-header">
                                    Регистрация шаг {{ currentStep }} из {{ totalSteps }}
                                </div>
                              <div v-if="isDaccord">
                                  <!-- Шаг 1 регистрации -->
                                  <div class="register-fields margin-bottom-15" v-if="currentStep === 1">
                                      <div class="form-field-group" v-for="(item, i) of currentRegFields" :key="i">
                                          <div class="form-field">
                                              <label class="input-text-lbl">
                                                  {{item.FieldName}}
                                              </label>
                                              <div v-if="item.isTradePoint">
                                                  <input name="TradePointName" type="text"
                                                      v-if="info.RegisterSettings.RegisterTradePointType === RegisterTradePointTypes.Text"
                                                      v-validate="'required'"
                                                      v-model="user.TradePointName"
                                                      :class="['input-text', {'input-error': errors.has('TradePointName')}]">
                                                  <search-filter :name="'TradePointName'" v-else-if="info.RegisterSettings.RegisterTradePointType === RegisterTradePointTypes.Select"
                                                      v-validate="{ rules: { required: true} }"
                                                      :hasErrors="errors.has('TradePointName')"
                                                      :extra="0"
                                                      :searchFunction="searchTPFunction"
                                                      :selectedItem="getSkuSelectedItem(tradePointSelected)"
                                                      :searchOnSelect="true"
                                                      :scrollable="true"
                                                      @onFilterChange="onChangeTPLinkSearch(...arguments)"></search-filter>
                                              </div>
                                              <div v-else-if="item.FieldName.includes('Введите ГОРОД')">
                                                    <city-search
                                                        :name="'fieldName' + i"
                                                        v-validate="{ rules: { required: true} }"
                                                        :selectedCity="selectedCity"
                                                        :hasErrors="errors.has('fieldName' + i)"
                                                        @update:selectedCity="onCitySelected(...arguments, item.FieldName)"
                                                    />
                                              </div>
                                              <div v-else>
                                                  <input :name="'fieldName' + i" type="text"
                                                      v-if="item.FieldType === 'text'"
                                                      v-validate="'required'"
                                                      v-model="item.Value"
                                                      :class="['input-text', {'input-error': errors.has('fieldName' + i)}]">
                                                  <drop-down v-else-if="item.FieldType === 'select'"
                                                      :items="item.optionsItems" :dataField="'Value'" :textField="'Name'" v-model="item.Value"></drop-down>
                                              </div>
                                          </div>
                                      </div>
                                      <div v-if="totalSteps > 1" class="form-actions">
                                          <div class="form-btns btns flex">
                                              <button type="button" class="btn btn-primary auth" @click="nextStep()">
                                                  Далее
                                              </button>
                                          </div>
                                      </div>
                                  </div>
                                  <!-- Динамические шаги регистрации -->
                                  <div class="register-fields margin-bottom-15" v-else-if="currentStep > 1 && currentStep < totalSteps">

                                    <div class="form-field-group">
                                        <div class="form-field">
                                            <input name="UserEmail" type="text" placeholder="Email"
                                                   v-validate="'required|email'"
                                                   v-model="user.Email"
                                                   data-vv-as='Email'
                                                   :class="['input-text', {'input-error': errors.has('UserEmail')}]"
                                                   @input="error = null">
                                            <span class="field-validation-valid">{{ errors.first('UserEmail') }}</span>

                                            <input style="display:none" type="text" name="Email" />
                                            <input style="display:none" type="password" name="Password" />
                                        </div>
                                    </div>

                                    <div class="form-field-group">
                                        <div class="form-field password-field">
                                            <input :type="showPassword ? 'text' : 'password'" name="UserPassword" placeholder="Пароль"
                                                   v-validate="'required'"
                                                   v-model="user.Password"
                                                   data-vv-as="Пароль"
                                                   :class="['input-text', {'input-error': errors.has('UserPassword')}]"
                                                   @input="onNewPasswordChange">
                                            <span class="toggle-password" @click="togglePasswordVisibility">
                                                <i :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'" aria-hidden="true"></i>
                                            </span>
                                            <span class="field-validation-valid">{{ errors.first('UserPassword') }}{{passwordError}}</span>
                                        </div>
                                        <div class="form-field password-field">
                                            <input :type="showPassword ? 'text' : 'password'" name="PasswordConfirm" placeholder="Повторите пароль"
                                                   v-validate="{required: true, confirmed: user.Password}"
                                                   v-model="user.PasswordConfirm"
                                                   data-vv-as="Повторите пароль"
                                                   :class="['input-text', {'input-error': errors.has('PasswordConfirm')}]">
                                            <span class="toggle-password" @click="togglePasswordVisibility">
                                                <i :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'" aria-hidden="true"></i>
                                            </span>
                                            <span class="field-validation-valid">{{ errors.first('PasswordConfirm') }}</span>
                                        </div>

                                    </div>

                                    <div class="form-field-group">
                                        <div class="form-field">
                                            <!--<label class="input-text-lbl">-->
                                            <!--Имя-->
                                            <!--<span class="required" aria-required="true">*</span>-->
                                            <!--</label>-->
                                            <input name="FirstName" type="text" placeholder="Имя"
                                                   v-validate="'required'"
                                                   v-model="user.FirstName"
                                                   data-vv-as='Имя'
                                                   :class="['input-text', {'input-error': errors.has('FirstName')}]">
                                            <span class="field-validation-valid">{{ errors.first('FirstName') }}</span>
                                        </div>
                                        <div class="form-field">
                                            <!--<label class="input-text-lbl">-->
                                            <!--Фамилия-->
                                            <!--<span class="required" aria-required="true">*</span>-->
                                            <!--</label>-->
                                            <input name="LastName" type="text" placeholder="Фамилия"
                                                   v-validate="'required'"
                                                   v-model="user.LastName"
                                                   data-vv-as='Фамилия'
                                                   :class="['input-text', {'input-error': errors.has('LastName')}]">
                                            <span class="field-validation-valid">{{ errors.first('LastName') }}</span>
                                        </div>

                                    </div>

                                    <div class="form-field-group">

                                        <div class="form-field">
                                            <!--<label class="input-text-lbl">-->
                                            <!--Отчество-->
                                            <!--<span class="required" aria-required="true"></span>-->
                                            <!--</label>-->
                                            <input name="MiddleName" type="text" class="input-text" v-model="user.MiddleName" placeholder="Отчество">
                                            <span class="field-validation-valid">{{ errors.first('MiddleName') }}</span>
                                        </div>
                                        <div class="form-field">
                                            <the-mask name="PhoneNumber" placeholder="Телефон"
                                                v-model="user.PhoneNumber"
                                                :mask="['### ### ### ### ### ### ### ### ### ### ### ### ### ### ### ### ### ### ###']"
                                                data-vv-as='Телефон'
                                                v-validate="{ required: true, regex: /^\d{11,}$/ }"
                                                :class="['input-text', {'input-error': errors.has('PhoneNumber')}]" />
                                            <span class="field-validation-valid">{{ errors.first('PhoneNumber') }}</span>
                                        </div>
                                    </div>

                                    <div class="form-field-group" v-for="(item, i) of currentRegFields" :key="i">
                                          <div class="form-field">
                                              <label class="input-text-lbl">
                                                  {{item.FieldName}}
                                              </label>
                                              <div v-if="item.isTradePoint">
                                                  <input name="TradePointName" type="text"
                                                      v-if="info.RegisterSettings.RegisterTradePointType === RegisterTradePointTypes.Text"
                                                      v-validate="'required'"
                                                      v-model="user.TradePointName"
                                                      :class="['input-text', {'input-error': errors.has('TradePointName')}]">
                                                  <search-filter :name="'TradePointName'" v-else-if="info.RegisterSettings.RegisterTradePointType === RegisterTradePointTypes.Select"
                                                      v-validate="{ rules: { required: true} }"
                                                      :hasErrors="errors.has('TradePointName')"
                                                      :extra="0"
                                                      :searchFunction="searchTPFunction"
                                                      :selectedItem="getSkuSelectedItem(tradePointSelected)"
                                                      :searchOnSelect="true"
                                                      :scrollable="true"
                                                      @onFilterChange="onChangeTPLinkSearch(...arguments)"></search-filter>
                                              </div>
                                              <div v-else>
                                                  <input :name="'fieldName' + i" type="text"
                                                      v-if="item.FieldType === 'text'"
                                                      v-validate="'required'"
                                                      v-model="item.Value"
                                                      :class="['input-text', {'input-error': errors.has('fieldName' + i)}]">
                                                  <drop-down v-else-if="item.FieldType === 'select'"
                                                      :items="item.optionsItems" :dataField="'Value'" :textField="'Name'" v-model="item.Value"></drop-down>
                                              </div>
                                          </div>
                                    </div>



                                      <div class="form-actions">
                                          <div class="form-btns btns flex">
                                              <button type="button" class="btn" @click="prevStep()">
                                                  Назад
                                              </button>
                                              <button type="button" class="btn btn-primary auth" @click="nextStep()">
                                                  Далее
                                              </button>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              <div v-else>
                                <!-- Шаг 1 регистрации -->
                                <div class="register-fields margin-bottom-15" v-if="currentStep === 1">
                                    <div class="form-field-group">
                                        <div class="form-field">
                                            <input name="UserEmail" type="text" placeholder="Email"
                                                   v-validate="'required|email'"
                                                   v-model="user.Email"
                                                   data-vv-as='Email'
                                                   :class="['input-text', {'input-error': errors.has('UserEmail')}]"
                                                   @input="error = null">
                                            <span class="field-validation-valid">{{ errors.first('UserEmail') }}</span>

                                            <input style="display:none" type="text" name="Email" />
                                            <input style="display:none" type="password" name="Password" />
                                        </div>
                                    </div>

                                    <div class="form-field-group">
                                        <div class="form-field password-field">
                                            <input :type="showPassword ? 'text' : 'password'" name="UserPassword" placeholder="Пароль"
                                                   v-validate="'required'"
                                                   v-model="user.Password"
                                                   data-vv-as="Пароль"
                                                   :class="['input-text', {'input-error': errors.has('UserPassword')}]"
                                                   @input="onNewPasswordChange">
                                            <span class="toggle-password" @click="togglePasswordVisibility">
                                                <i :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'" aria-hidden="true"></i>
                                            </span>
                                            <span class="field-validation-valid">{{ errors.first('UserPassword') }}{{passwordError}}</span>
                                        </div>
                                        <div class="form-field password-field">
                                            <input :type="showPassword ? 'text' : 'password'" name="PasswordConfirm" placeholder="Повторите пароль"
                                                   v-validate="{required: true, confirmed: user.Password}"
                                                   v-model="user.PasswordConfirm"
                                                   data-vv-as="Повторите пароль"
                                                   :class="['input-text', {'input-error': errors.has('PasswordConfirm')}]">
                                            <span class="toggle-password" @click="togglePasswordVisibility">
                                                <i :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'" aria-hidden="true"></i>
                                            </span>
                                            <span class="field-validation-valid">{{ errors.first('PasswordConfirm') }}</span>
                                        </div>

                                    </div>

                                    <div class="form-field-group">
                                        <div class="form-field">
                                            <!--<label class="input-text-lbl">-->
                                            <!--Имя-->
                                            <!--<span class="required" aria-required="true">*</span>-->
                                            <!--</label>-->
                                            <input name="FirstName" type="text" placeholder="Имя"
                                                   v-validate="'required'"
                                                   v-model="user.FirstName"
                                                   data-vv-as='Имя'
                                                   :class="['input-text', {'input-error': errors.has('FirstName')}]">
                                            <span class="field-validation-valid">{{ errors.first('FirstName') }}</span>
                                        </div>
                                        <div class="form-field">
                                            <!--<label class="input-text-lbl">-->
                                            <!--Фамилия-->
                                            <!--<span class="required" aria-required="true">*</span>-->
                                            <!--</label>-->
                                            <input name="LastName" type="text" placeholder="Фамилия"
                                                   v-validate="'required'"
                                                   v-model="user.LastName"
                                                   data-vv-as='Фамилия'
                                                   :class="['input-text', {'input-error': errors.has('LastName')}]">
                                            <span class="field-validation-valid">{{ errors.first('LastName') }}</span>
                                        </div>

                                    </div>

                                    <div class="form-field-group">

                                        <div class="form-field">
                                            <!--<label class="input-text-lbl">-->
                                            <!--Отчество-->
                                            <!--<span class="required" aria-required="true"></span>-->
                                            <!--</label>-->
                                            <input name="MiddleName" type="text" class="input-text" v-model="user.MiddleName" placeholder="Отчество">
                                            <span class="field-validation-valid">{{ errors.first('MiddleName') }}</span>
                                        </div>
                                        <div class="form-field">
                                            <the-mask name="PhoneNumber" placeholder="Телефон"
                                                v-model="user.PhoneNumber"
                                                :mask="['### ### ### ### ### ### ### ### ### ### ### ### ### ### ### ### ### ### ###']"
                                                data-vv-as='Телефон'
                                                v-validate="{ required: true, regex: /^\d{11,}$/ }"
                                                :class="['input-text', {'input-error': errors.has('PhoneNumber')}]" />
                                            <span class="field-validation-valid">{{ errors.first('PhoneNumber') }}</span>
                                        </div>
                                    </div>
                                    <div v-if="totalSteps > 1" class="form-actions">
                                        <div class="form-btns btns flex">
                                            <button type="button" class="btn btn-primary auth" @click="nextStep()">
                                                Далее
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <!-- Динамические шаги регистрации -->
                                <div class="register-fields margin-bottom-15" v-else-if="currentStep > 1 && currentStep < totalSteps">
                                    <div class="form-field-group" v-for="(item, i) of currentRegFields" :key="i">
                                        <div class="form-field">
                                            <label class="input-text-lbl">
                                                {{item.FieldName}}
                                            </label>
                                            <div v-if="item.isTradePoint">
                                                <input name="TradePointName" type="text"
                                                    v-if="info.RegisterSettings.RegisterTradePointType === RegisterTradePointTypes.Text"
                                                    v-validate="'required'"
                                                    v-model="user.TradePointName"
                                                    :class="['input-text', {'input-error': errors.has('TradePointName')}]">
                                                <search-filter :name="'TradePointName'" v-else-if="info.RegisterSettings.RegisterTradePointType === RegisterTradePointTypes.Select"
                                                    v-validate="{ rules: { required: true} }"
                                                    :hasErrors="errors.has('TradePointName')"
                                                    :extra="0"
                                                    :searchFunction="searchTPFunction"
                                                    :selectedItem="getSkuSelectedItem(tradePointSelected)"
                                                    :searchOnSelect="true"
                                                    :scrollable="true"
                                                    @onFilterChange="onChangeTPLinkSearch(...arguments)"></search-filter>
                                            </div>
                                            <div v-else>
                                                <input :name="'fieldName' + i" type="text"
                                                    v-if="item.FieldType === 'text'"
                                                    v-validate="'required'"
                                                    v-model="item.Value"
                                                    :class="['input-text', {'input-error': errors.has('fieldName' + i)}]">
                                                <drop-down v-else-if="item.FieldType === 'select'"
                                                    :items="item.optionsItems" :dataField="'Value'" :textField="'Name'" v-model="item.Value"></drop-down>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-actions">
                                        <div class="form-btns btns flex">
                                            <button type="button" class="btn" @click="prevStep()">
                                                Назад
                                            </button>
                                            <button type="button" class="btn btn-primary auth" @click="nextStep()">
                                                Далее
                                            </button>
                                        </div>
                                    </div>
                                </div>
                              </div>

                                <!-- Финальный шаг регистрации -->
                                <div v-if="currentStep === totalSteps">
                                    <div class="form-field">
                                        <input id="NotificationsEnabled" v-model="user.NotificationsEnabled" name="NotificationsEnabled" value="true" type="checkbox" class="input-checkbox" />
                                        <label for="NotificationsEnabled" class="input-checkbox-lbl">
                                            Я хочу получать
                                            новости и оповещения по email и
                                            sms
                                        </label>
                                    </div>
                                    <div class="form-field">
                                        <input id="TermsConfirmed"
                                            v-model="user.TermsConfirmed" v-validate="'required'" name="TermsConfirmed" value="true" type="checkbox" class="input-checkbox" />
                                        <label for="TermsConfirmed" :class="['input-checkbox-lbl', {'error': errors.has('TermsConfirmed')}]">
                                            Я согласен с <a v-if="info.RulesFile" href="javascript:;" @click.stop="onShowRulesClick" style="color:#ff0000">правилами программы</a>
                                            <span v-if="!info.RulesFile">правилами программы</span>
                                        </label>
                                    </div>
                                    <div class="form-field">
                                        <input id="PersonalDataEditingAccept"
                                            v-model="user.PersonalDataEditingAccept"
                                            v-validate="'required'" name="PersonalDataEditingAccept" value="true" type="checkbox" class="input-checkbox" />
                                        <label for="PersonalDataEditingAccept" :class="['input-checkbox-lbl', {'error': errors.has('PersonalDataEditingAccept')}]">
                                            Я согласен на обработку
                                            <a v-if="info.PolicyFile" href="javascript:;" @click.stop="onShowPolicyClick" style="color:#ff0000">персональных данных</a><span v-if="!info.PolicyFile">персональных данных</span>
                                          <span v-if="isCampari">и с</span>
                                          <a v-if="info.PolicyFile && isCampari" href="javascript:;" @click.stop="onShowPolicyClick" style="color:#ff0000">
                                            политикой конфиденциальности
                                          </a>
                                        </label>
                                    </div>
                                    <div class="form-actions">
                                        <div class="form-btns btns flex">
                                            <button v-if="totalSteps > 1" type="button" class="btn" @click="prevStep()">
                                                Назад
                                            </button>
                                            <button type="button" class="btn btn-primary auth" @click="register()">
                                                Зарегистрироваться
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <span class="field-validation-valid">{{ error }}</span>
                                <div class="reglink margin-top-20">
                                    <p>Уже зарегистрированы? <span @click="$router.push('/login')">Войти</span></p>
                                </div>
                            </template>
                        </div>
                        <template v-if="result != null">
                            <div class="auth-content-block">
                                Для завершения регистрации требуется подтвердить указанный email.<br />
                                Проверьте почту и следуйте инструкциям.
                            </div>
                        </template>
                    </div>
                </div>
            </div>
                
            </div>

            <popup-window ref="ppPolicy" :title="'Политика конфиденциальности сервиса'" :width="800" :height="'90%'">
                <p class="p-header-1"></p>
                <template v-if="info.PolicyFile">
                    <iframe v-if="policyFile.ishtml" :src="policyFile.url"></iframe>
                    <pdf-viewer v-else ref="pdfViewPolicy"></pdf-viewer>
                </template>
            </popup-window>

            <popup-window ref="ppRules" :title="'Правила программы'" :width="800" :height="'90%'">
                <p class="p-header-1"></p>
                <template v-if="info.RulesFile">
                    <iframe v-if="rulesFile.ishtml" :src="rulesFile.url"></iframe>
                    <pdf-viewer v-else ref="pdfViewRules"></pdf-viewer>
                </template>
            </popup-window>

            <vue-headful title="Регистрация" />
        </div>
</template>

<script>
  import $ from 'jquery'
  import UI from '../helpers/ui-helpers'
  import config from '../config'
  import BackendApi from '../backendApi'
    import { RegisterTradePointTypes } from '../enums'
  import citiesData from '../cities.json'
  import CitySearch from "../components/CitySearch.vue";

    let backendApi = new BackendApi();

    export default {
        name: "register",
      components: {CitySearch},

        props: ['info'],

        data() {
            return {
                error: null,
                passwordError: null,
                result: null,
                user: {},
                apiUrl: config.apiUrl,
                tradePoints: [],
                tradePointSelected: {},
                RegisterTradePointTypes,
                regFields: [],
                rulesFile: {},
                policyFile: {},
                currentStep: 1,
                totalSteps: 1,
                currentRegFields: [],
                showPassword: false,
                selectedCity: null, // Выбранный город
                citiesData: citiesData, // Данные с городами
                isDaccord: false,
                isCampari: false
            };
        },

        methods: {
            searchCities(searchText, callback) {
                const results = this.citiesData
                    .filter(city => city.city.toLowerCase().includes(searchText.toLowerCase()))
                    .map(city => ({ Name: `${city.city}, ${city.region}`, Id: `${city.city}, ${city.region}` }));

                // Если не найдено — добавляем введенный текст
                if (results.length === 0) {
                    results.push({ Name: searchText });
                }

                callback(results);
            },
            // Обработка выбора города
            onCitySelected(city, fieldName) {
                let field = this.currentRegFields.find( x =>  x.FieldName === fieldName);
                field.Value = city.Name;
                this.selectedCity = city;
            },
            register() {
                let vm = this;

                vm.error = null;
                this.$validator.validate().then(result => {
                    if (result) {
                        vm.user.RegFields = [];
                        for (let field of vm.regFields) {
                            vm.user.RegFields.push({ FieldToAnswer: field.FieldToAnswer, FieldValue: field.Value });
                        }
                        let saveObj = Object.assign({}, vm.user, {});
                        console.info('register', saveObj);
                        backendApi.userRegister(saveObj).then(function (response) {
                            console.info('backendApi.userRegister, response:', response);
                            if (response.hasError) {
                                if (response.status === 201) {
                                    vm.error = 'Ошибка. Проверьте введённые данные';
                                } else if (response.status === 8) {
                                    vm.error = 'Email уже используется';
                                } else if (response.status === 9) {
                                    vm.passwordError = 'Некорректное значение';
                                } else {
                                    UI.toastr.error('Ошибка при регистрации');
                                }
                            } else {
                                if (response.data != null) {
                                    vm.result = response.data;
                                }
                            }
                        });
                    }
                });
            },

            onNewPasswordChange() {
                this.passwordError = null;

                if (!this.user.Password || !this.user.Password.trim()) {
                    this.password.Error = null;
                } else {
                    let newpass = this.user.Password;

                    if (newpass.length < 6) {
                        this.passwordError = 'Введите минимум 6 символов';
                    } else if (!/(?=.*\d).*\D.*/ig.test(newpass)) {
                        this.passwordError = 'Обязательно наличие и букв и цифр';
                    } else if (!/(?=.*[A-ZА-Я]).*[a-zа-я].*/g.test(newpass)) {
                        this.passwordError = 'Обязательно наличие заглавной и прописной буквы';
                    }
                }
            },

            onShowRulesClick() {
                let vm = this;
                vm.$refs.ppRules.show();
                if (!vm.rulesFile.ishtml) {
                    vm.$nextTick(() => {
                        vm.$refs.pdfViewRules.show(vm.rulesFile.url);
                    });
                }
            },

            onShowPolicyClick() {
                let vm = this;
                vm.$refs.ppPolicy.show();
                if (!vm.policyFile.ishtml) {
                    vm.$nextTick(() => {
                        vm.$refs.pdfViewPolicy.show(vm.policyFile.url);
                    });
                }
            },

            loadTradePoints() {
                let vm = this;
                vm.callApiWrapper(backendApi.tradePointListForRegister(0, 100))
                    .then(function (resp) {
                        vm.tradePoints = resp.data;
                        vm.tradePointsOriginal = resp.data;
                    });
            },

            getSkuSelectedItem(tradePointSelected) {
                return {
                    Name: tradePointSelected.Name,
                    Id: tradePointSelected.Id
                }
            },

            searchTPFunction(searchText, callback, extra, page) {
                let vm = this;
                vm.callApiWrapper(backendApi.tradePointListForRegister((page - 1) * 20, 20, searchText))
                    .then(function (resp) {
                        callback(resp.data);
                    });
            },

            onChangeTPLinkSearch(listItem, extra, fieldName) {
                if (listItem) {
                    this.user.TradePointName = listItem.Name;
                    this.user.TradePointId = listItem.Id;
                    this.tradePointSelected = listItem;
                }else {
                    this.user.TradePointName = '';
                    this.user.TradePointId = null;
                    this.tradePointSelected = {};
                }
            },

            nextStep() {
              this.$validator.validateAll().then(result => {
                if (!result) {
                    console.log("Ошибки валидации:", this.errors.items);
                    return; // Остановить переход на следующий шаг, если есть ошибки
                }

                // Проверяем, есть ли ошибка в поле пароля
                if (this.passwordError) {
                    console.log("Ошибка пароля:", this.passwordError);
                    return; // Остановить переход, если есть ошибка в пароле
                }

                /*// Логика для расчета общего количества шагов (например, если это первый шаг)
                if (this.currentStep === 1) {
                    this.totalSteps = 2 + Math.ceil((this.regFields.length + (this.info.RegisterSettings.RegisterTradePointDisabled ? 0 : 1)) / 4);
                }*/

                // Переход на следующий шаг, если ошибок нет
                if (this.currentStep < this.totalSteps) {
                    this.currentStep++;
                    this.updateCurrentRegFields();
                }
              });
            },

            prevStep() {
                if (this.currentStep > 1) {
                    this.currentStep--;
                    this.updateCurrentRegFields();
                }
            },

            updateCurrentRegFields() {
                let startIndex = (this.currentStep - 2) * 4;
                if (!this.info.RegisterSettings.RegisterTradePointDisabled) {
                  if(this.isDaccord){
                    if(this.currentStep === 1){
                        this.currentRegFields = [this.regFields[0], this.tradePointField, ...this.regFields.slice(1, this.regFields.length - 1)]
                    } else {
                        this.currentRegFields = [this.regFields[this.regFields.length - 1]];
                    }
                  } else {
                    if(this.currentStep === 2){
                        this.currentRegFields = [this.tradePointField, ...this.regFields.slice(startIndex, startIndex + 3)];
                    } else {
                        startIndex -= 1;
                        this.currentRegFields = this.regFields.slice(startIndex, startIndex + 4);
                    }
                  }

                } else {
                    this.currentRegFields = this.regFields.slice(startIndex, startIndex + 4);
                }
            },

            initPage() {
                let vm = this;
                let fields = this.info.RegisterSettings.RegFields;
                for (let x = 0; x < fields.length; x++) {
                    let field = { Id: fields[x].Id, FieldName: fields[x].FieldName, FieldType: fields[x].FieldType, Options: fields[x].Options, FieldToAnswer: fields[x].FieldToAnswer, Value: '' };
                    if (fields[x].FieldType === 'select')
                        field.optionsItems = JSON.parse(fields[x].Options).map(y => ({ Value: y, Name: y }));
                    vm.regFields.push(field);
                }

                if (!this.info.RegisterSettings.RegisterTradePointDisabled) {
                    this.tradePointField = {
                        FieldName: this.info.RegisterSettings.RegisterTradePointName,
                        FieldType: this.info.RegisterSettings.RegisterTradePointType,
                        Value: this.user.TradePointName,
                        isTradePoint: true
                    };
                    if (this.info.RegisterSettings.RegisterTradePointType === 'select') {
                        this.tradePointField.optionsItems = this.tradePoints.map(tp => ({ Value: tp.Name, Name: tp.Name }));
                    }
                }

                vm.policyFile.url = (vm.info.PolicyFile.indexOf('https') > -1) ? vm.info.PolicyFile : (config.apiUrl + vm.info.PolicyFile);
                vm.policyFile.ishtml = vm.policyFile.url.indexOf('.html') > -1;
                vm.rulesFile.url = (vm.info.RulesFile.indexOf('https') > -1) ? vm.info.RulesFile : (config.apiUrl + vm.info.RulesFile);
                vm.rulesFile.ishtml = vm.rulesFile.url.indexOf('.html') > -1;

                if (this.regFields.length > 0 || !this.info.RegisterSettings.RegisterTradePointDisabled)
                  if(this.isDaccord){
                    this.totalSteps = 3
                  } else {
                    this.totalSteps = 2 + (Math.ceil((this.regFields.length + (this.info.RegisterSettings.RegisterTradePointDisabled ? 0 : 1)) / 4));
                  }
                this.updateCurrentRegFields();
            },
            togglePasswordVisibility() {
                this.showPassword = !this.showPassword;
            }
        },

        mounted() {
            this.isDaccord = this.info.PolicyFile && (this.info.PolicyFile.includes("promo.ofrs.su") || this.info.PolicyFile.includes("daccord.club"));
            this.isCampari = this.info.PolicyFile && (this.info.PolicyFile.includes("promo.ofrs.su") || this.info.PolicyFile.includes("campari.pro"));
            //console.info('this.info.RegisterSettings', this.info.RegisterSettings);
            if(!this.info.RegisterSettings.Enabled) {
                this.$router.push('/');
            } else {
                this.initPage();
            }
          //else if (this.info.RegisterSettings.RegisterTradePointType === RegisterTradePointTypes.Select) {
          //    this.loadTradePoints();
          //}
      }

  }
</script>

<style>
    .dropdown-block{ height: 60px; }
    .dropdown-block a{ padding-top: 15px !important;text-overflow:ellipsis;overflow:hidden;}
    /*.form-field-group .form-field{flex-basis: 100%;width: 0;}*/
    .dropdown-menu-open .dropdown-list {right: 0;left: auto;}
    .register-fields{display:block; position:relative;padding: 0px 10px 0px 0px;}
    .password-field {
    position: relative;
    }

    .toggle-password {
        position: absolute;
        right: 20px;
        top: 20px;
        cursor: pointer;
    }

    .fa-eye, .fa-eye-slash {
        font-size: 1.4em;
    }
</style>


// WEBPACK FOOTER //
// Content/src/views/Register.vue